import { mapGetters, mapMutations } from "vuex";

export default {
    name: "CosmoBaseBanner",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/content"
      })
    },
    methods: {
      ...mapMutations({
        changeCosmoBaseFormPopup: "popups/CHANGE_COSMOBASE_FORM_POPUP",
      }),
      openCosmoBaseForm() {
        const anchor = document.querySelector("#plans");
        this.$smoothScroll({
          scrollTo: anchor,
          duration: 1000,
        });
      }
    }
}
